<h1 mat-dialog-title> Crear convenio colaboración </h1> <br/>

<form #convenioColaboracionForm=ngForm>
    
    <mat-dialog-content>

        <p>
            <mat-label>
                <h2> Convenio </h2>
            </mat-label>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> RUT </mat-label>

                <input name="rut" matInput [(ngModel)]="convenioColaboracion.rut" required placeholder="Formato: 11111111-1" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" #rut="ngModel" />

            </mat-form-field>
        </p>
      

        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Nombre </mat-label>

                <input name="nombre" id="nombre" matInput required [(ngModel)]="convenioColaboracion.nombre" (ngModelChange)="convenioColaboracion.nombre = $event.toUpperCase()" #nombre="ngModel" />

            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Razón Social </mat-label>

                <input name="razonSocial" id="razonSocial" matInput required [(ngModel)]="convenioColaboracion.razonSocial" (ngModelChange)="convenioColaboracion.razonSocial = $event.toUpperCase()" #razonSocial="ngModel" />

            </mat-form-field>
        </p>      
        <p>
            <mat-form-field appearance="outline" class="mat-input">
                <mat-label> Región </mat-label>
                <mat-select name="idRegion" id="idRegion" #idRegion="ngModel" [(ngModel)]="convenioColaboracion.idRegion" required >
                    <mat-option value=0>

                        SELECCIONE....

                    </mat-option>
                    <mat-option *ngFor="let r of this.regiones" value="{{r.id}}">

                        {{r.nombre}}

                    </mat-option>
                </mat-select>
            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance="outline" class="mat-input">
                <mat-label> Fecha Inicio </mat-label>
                <input name="fechaInicio" id="fechaInicio" type="date"  matInput required [(ngModel)]="convenioColaboracion.fechaInicio" (ngModelChange)="convenioColaboracion.fechaInicio = $event.toUpperCase()" #fechaInicio="ngModel" />
            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance="outline" class="mat-input">
                <mat-label>  Fecha Fin </mat-label>
                <input name="fechaFin" id="fechaFin" type="date"  matInput required [(ngModel)]="convenioColaboracion.fechaFin" (ngModelChange)="convenioColaboracion.fechaFin = $event.toUpperCase()" #fechaFin="ngModel" />
            </mat-form-field>
        </p>
        <p> 
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Descripción del Beneficio </mat-label>

                <textarea name="descripcion" id="descripcion" matInput required  cols="55" rows="5" [(ngModel)]="convenioColaboracion.descripcion" (ngModelChange)="$event.toUpperCase()"></textarea>

            
            </mat-form-field>
        </p>  
        <!---
        <p> 
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Adjuntar </mat-label>
               
                <input name = "archivo" matInput [value] = "convenioColaboracion?.archivo?.name" disabled = "true" />
            </mat-form-field>
            <input #csvInput hidden = "true" type = "file" enctype = "multipart/form-data" onclick = "this.value = null" 
            (change) = "csvInputChange($event)" accept = "application/pdf, image/jpeg, image/jpg, image/png"/>

            <button mat-flat-button color = "primary" (click) = "csvInput.click()"> Seleccione Archivo (pdf,jpeg,jpg,png) </button>

        </p>
        --->

        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Adjuntar</mat-label>
                <div class="col-lg-6">
                    <input #archivo [(ngModel)]="convenioColaboracion.archivoTest" type="file" class="form-control-file" name="archivo"  (change)="seleccionaArchivo($event)" required accept="application/pdf, image/jpeg, image/jpg, image/png">
               </div>

            </form-field>

        </p>
       
        <!---(change)="csvInputChange($event)"
        <p> 
            <mat-form-field appearance="outline" class="mat-input">

                <div class="col-lg-1"> </div>

                <mat-label> Adjuntar </mat-label>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="convenioColaboracion.archivo" (change)="seleccionaArchivo($event, 0)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" > + </button> </div>
               
                <div class="col-lg-1"> </div>
                <div *ngIf="convenioColaboracion.errors && convenioColaboracion.touched" class="alert alert-danger">

                    <div *ngIf="convenioColaboracion.errors.required"> Ingrese al menos un (1) archivo. </div>

                </div>
               
            </mat-form-field>
        </p> 
          --->
     
       

    </mat-dialog-content> <br/>
</form>
<mat-dialog-actions>
    <button mat-button class="mat-raised-button btn-success" (click)="onCrearconvenioColaboracionClick(convenioColaboracionForm)"> 
            <i class = "fa fa-plus"> </i> Crear
        </button>

    <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()"> 
            <i class = "fa fa-trash"> </i> Salir
        </button>

</mat-dialog-actions>

<br/>